function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
import Big from 'big.js';
import { calcTaxes, flattenTaxes, layerOrder, relevantTaxRules, sumTaxesAtLayer } from 'shared/helpers/taxes';
// eslint-disable-next-line import/no-cycle
import { getProductWeight } from 'shared/helpers/products';
// eslint-disable-next-line import/no-cycle
import { productSatisfiesSaleWeight } from 'shared/helpers/specials';
var findStageIndex = function(stage) {
    return _.findIndex(layerOrder, function(s) {
        return s === stage;
    });
};
export function sumProductTaxes(detail, products, cannabisTaxTotal, salesTaxTotal) {
    var _detail_mixAndMatch;
    var basePrice = ((_detail_mixAndMatch = detail.mixAndMatch) === null || _detail_mixAndMatch === void 0 ? void 0 : _detail_mixAndMatch.adjustedBasePrice) || detail.basePrice;
    var price = basePrice.times(detail.quantity);
    var qtyWholesalePrice = detail.wholesalePrice.times(detail.quantity);
    var whPrice = qtyWholesalePrice.round(2, 1);
    var item = products["".concat(detail.id, "_").concat(detail.option)];
    var cannabisTax = detail.cannabisTax(price, whPrice, item === null || item === void 0 ? void 0 : item.product, item === null || item === void 0 ? void 0 : item.option);
    var salesTax = detail.salesTax(price, whPrice, item === null || item === void 0 ? void 0 : item.product, item === null || item === void 0 ? void 0 : item.option);
    cannabisTaxTotal = cannabisTaxTotal.plus(cannabisTax);
    salesTaxTotal = salesTaxTotal.plus(salesTax);
    return {
        cannabisTaxTotal: cannabisTaxTotal,
        salesTaxTotal: salesTaxTotal
    };
}
export var gatherProductTaxes = function(detailsSorted, products) {
    // we need to gather the total taxes for the products so we can include that in the price that we amortize the
    // discount across in the applyTaxPreDiscount case
    var salesTaxTotal = Big(0);
    var cannabisTaxTotal = Big(0);
    var bottleDepositTaxTotal = Big(0);
    _.forEach(detailsSorted, function(productDetail) {
        var productTaxes = sumProductTaxes(productDetail, products, cannabisTaxTotal, salesTaxTotal);
        cannabisTaxTotal = productTaxes.cannabisTaxTotal;
        salesTaxTotal = productTaxes.salesTaxTotal;
        // Matches getUpdatedTaxes' bottleDepositTaxCents (cents); sole caller (rewards.js) needs this
        // included so its tax-inclusive subtotal matches originalCompositePrice's postTaxPrice basis.
        bottleDepositTaxTotal = bottleDepositTaxTotal.plus((productDetail.bottleDepositTaxCents || Big(0)).times(productDetail.quantity));
    });
    return cannabisTaxTotal.plus(salesTaxTotal).plus(bottleDepositTaxTotal.div(100));
};
export var taxes = function(cart, dispensary, medicalOrder, isDelivery) {
    var toMenu = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var _dispensary_location, _taxExistence_med, _taxExistence_rec, _taxExistence_med1, _taxExistence_rec1, _taxExistence_med2, _taxExistence_rec2;
    // The FE sometimes passes in dispensaries wrapped in mbox proxies which don't don't
    // like the data structues being changed outside of their perview.  We make a top level
    // copy so that we can munge it later on if necessary.
    var taxData = _object_spread({}, _.get(dispensary, "taxConfig", {
        taxes: []
    }));
    var taxRules = flattenTaxes(taxData);
    var appliedTaxRules;
    var details = [];
    var taxExistence = {
        med: {
            sales: {},
            cannabis: {},
            bottleDeposit: {}
        },
        rec: {
            sales: {},
            cannabis: {},
            bottleDeposit: {}
        }
    };
    var cannabisTax = Big(0), salesTax = Big(0), bottleDepositTaxCents = Big(0), subtotal = Big(0);
    // In the Saskatchwan there are some products which are determined by the government
    // to have a different PST.  These are nominally specific vape products.  We setup the
    // those tax rules to be applied later.  This only ever applies to SK dispensaries, and the
    // resulting rules are identical for every cart item, so compute it once up front rather than
    // re-deriving (and re-cloning taxRules) on every iteration of the cart below.
    var isSaskatchewanDispensary = ((_dispensary_location = dispensary.location) === null || _dispensary_location === void 0 ? void 0 : _dispensary_location.state) === 'SK';
    var vapeTaxRules = isSaskatchewanDispensary ? _.map(taxRules, function(rule) {
        return rule.name === 'PST' ? _object_spread_props(_object_spread({}, rule), {
            name: 'Vape',
            rate: 0.2
        }) : rule;
    }) : null;
    _.forEach(cart, function(item) {
        var _item_product_POSMetaData, _item_product, _item_product_wholesalePrices, _item_product1, _item_product_specialData, _item_product2, _item_product3, _item_product4, _item_product5, _item_product_brand, _item_product6, _item_product_brand1, _item_product7, _item_product8;
        var thcRange = _.get(item, 'product.THCContent.range', []);
        var thcContent = _.max(thcRange) || 0; // Default to 0 if range is empty
        var isVapeTaxed = isSaskatchewanDispensary && item.product.vapeTaxApplicable;
        _.forEach([
            'med',
            'rec'
        ], function(type) {
            var rules = relevantTaxRules(item.product.type, false, type, taxRules);
            _.forEach([
                'sales',
                'cannabis',
                'bottleDeposit'
            ], function(taxType) {
                var taxTypeRules = _.filter(rules, [
                    'type',
                    taxType
                ]);
                _.forEach([
                    'pos',
                    'menu',
                    'checkout'
                ], function(stage) {
                    var stageIndex = findStageIndex(stage);
                    var tax = sumTaxesAtLayer(_.filter(taxTypeRules, function(r) {
                        var _r_stage;
                        return findStageIndex((_r_stage = r.stage) === null || _r_stage === void 0 ? void 0 : _r_stage.type) <= stageIndex;
                    }), item);
                    if (taxTypeRules.length) {
                        taxExistence[type][taxType][stage] = tax.gt(0);
                    }
                });
            });
        });
        // We determine when this is true based on a an attribute on the product.  Someday we might be
        // able to do this by less invasive techniques but for now we're going to hard code this mess.
        appliedTaxRules = isVapeTaxed ? vapeTaxRules : taxRules;
        var menuTaxValues = calcTaxes({
            category: item.product.type,
            hemp: item.product.hemp,
            thcContent: thcContent,
            type: medicalOrder ? "med" : "rec",
            taxRules: appliedTaxRules,
            taxMethod: taxData.calculationMethod,
            stage: toMenu ? "menu" : "checkout",
            isDelivery: isDelivery,
            product: item.product,
            option: item.option,
            dispensary: dispensary,
            quantity: item.quantity
        });
        // Given a raw value how do we get to checkout.
        var checkoutTaxValues = calcTaxes({
            category: item.product.type,
            hemp: item.product.hemp,
            thcContent: thcContent,
            type: medicalOrder ? "med" : "rec",
            taxRules: appliedTaxRules,
            taxMethod: taxData.calculationMethod,
            stage: toMenu ? "menu" : "checkout",
            initialStage: "base",
            isDelivery: isDelivery,
            product: item.product,
            option: item.option,
            dispensary: dispensary,
            quantity: item.quantity
        });
        // Given a menu value how do we get back to base.
        var posTaxValues = calcTaxes({
            category: item.product.type,
            hemp: item.product.hemp,
            thcContent: thcContent,
            type: medicalOrder ? "med" : "rec",
            taxRules: appliedTaxRules,
            taxMethod: taxData.calculationMethod,
            stage: toMenu ? "pos" : "menu",
            initialStage: "base",
            isDelivery: isDelivery,
            product: item.product,
            option: item.option,
            dispensary: dispensary,
            quantity: item.quantity
        });
        var index = _.findIndex(item.product.Options, function(option) {
            return option === item.option;
        });
        var metadata = _.find((_item_product_POSMetaData = item.product.POSMetaData) === null || _item_product_POSMetaData === void 0 ? void 0 : _item_product_POSMetaData.children, function(child) {
            return [
                child.option,
                item.option
            ];
        });
        var price = Big(item.price, "Item Price ".concat(item === null || item === void 0 ? void 0 : (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product._id));
        var wholesalePrice = Big(((_item_product1 = item.product) === null || _item_product1 === void 0 ? void 0 : (_item_product_wholesalePrices = _item_product1.wholesalePrices) === null || _item_product_wholesalePrices === void 0 ? void 0 : _item_product_wholesalePrices[index]) || 0);
        bottleDepositTaxCents = bottleDepositTaxCents.add(menuTaxValues.bottleDepositTaxCents);
        cannabisTax = cannabisTax.add(menuTaxValues.cannabisTax(item.price, wholesalePrice, item.product, item.option));
        salesTax = salesTax.add(menuTaxValues.salesTax(item.price, wholesalePrice, item.product, item.option));
        subtotal = subtotal.add(price);
        var basePrice;
        if (item.product.id === "Adhoc") {
            basePrice = Big(item.product.Prices[index], "Adhoc Base Price");
        } else {
            basePrice = Big(// TODO WEHRMAN COME BACK TO THIS something is borking our index...
            medicalOrder ? item.product.medicalPrices[index < 0 ? 0 : index] : item.product.recPrices[index < 0 ? 0 : index], "Base Price").minus(posTaxValues.bottleDepositTaxCents.div(100)).div(posTaxValues.taxMult);
        }
        var weightInGrams = getProductWeight(item.option);
        var isOnSale = productSatisfiesSaleWeight(item.product, ((_item_product2 = item.product) === null || _item_product2 === void 0 ? void 0 : (_item_product_specialData = _item_product2.specialData) === null || _item_product_specialData === void 0 ? void 0 : _item_product_specialData.saleSpecials) || [], item.option, false);
        var _item_product_brandId;
        details.push({
            type: "product",
            id: item.product._id,
            enterpriseProductId: item === null || item === void 0 ? void 0 : (_item_product3 = item.product) === null || _item_product3 === void 0 ? void 0 : _item_product3.enterpriseProductId,
            posId: (_.find(_.get(item, "product.POSMetaData.children", []), [
                "option",
                item.option
            ]) || {}).canonicalID,
            option: item.option,
            quantity: Number(item.quantity),
            basePrice: basePrice,
            isOnSale: isOnSale,
            key: "".concat(item.product._id, "_").concat(item.option || 'N/A'),
            weightInGrams: weightInGrams,
            weightInMg: Number(weightInGrams * 1000),
            wholesalePrice: wholesalePrice,
            pricingTierData: (_item_product4 = item.product) === null || _item_product4 === void 0 ? void 0 : _item_product4.pricingTierData,
            productBrandId: (_item_product_brandId = (_item_product5 = item.product) === null || _item_product5 === void 0 ? void 0 : _item_product5.brandId) !== null && _item_product_brandId !== void 0 ? _item_product_brandId : item === null || item === void 0 ? void 0 : (_item_product6 = item.product) === null || _item_product6 === void 0 ? void 0 : (_item_product_brand = _item_product6.brand) === null || _item_product_brand === void 0 ? void 0 : _item_product_brand.id,
            productBrand: ((_item_product7 = item.product) === null || _item_product7 === void 0 ? void 0 : (_item_product_brand1 = _item_product7.brand) === null || _item_product_brand1 === void 0 ? void 0 : _item_product_brand1.name) || ((_item_product8 = item.product) === null || _item_product8 === void 0 ? void 0 : _item_product8.brandName),
            productCategory: item.product.type,
            productSubcategory: item.product.subcategory,
            basePriceMult: posTaxValues.taxMult,
            cannabisTax: checkoutTaxValues.cannabisTax,
            salesTax: checkoutTaxValues.salesTax,
            bottleDepositTaxCents: checkoutTaxValues.bottleDepositTaxCents,
            specialData: item.product.specialData,
            menuBasePrice: item.basePrice || 0,
            menuIndividualPrice: !_.isNil(item.discountedBasePrice) ? item.discountedBasePrice : item.basePrice || 0,
            menuPrice: item.price,
            menuCannabisTax: posTaxValues.cannabisTax(item.price, wholesalePrice, item.product, item.option),
            menuSalesTax: posTaxValues.salesTax(item.price, wholesalePrice, item.product, item.option),
            isVapeTaxed: isVapeTaxed,
            canonicalEffectivePotencyMg: metadata === null || metadata === void 0 ? void 0 : metadata.canonicalEffectivePotencyMg
        });
    });
    var salesTaxExistence = {
        med: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_med = taxExistence.med) === null || _taxExistence_med === void 0 ? void 0 : _taxExistence_med.sales,
        rec: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_rec = taxExistence.rec) === null || _taxExistence_rec === void 0 ? void 0 : _taxExistence_rec.sales
    };
    var cannabisTaxExistence = {
        med: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_med1 = taxExistence.med) === null || _taxExistence_med1 === void 0 ? void 0 : _taxExistence_med1.cannabis,
        rec: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_rec1 = taxExistence.rec) === null || _taxExistence_rec1 === void 0 ? void 0 : _taxExistence_rec1.cannabis
    };
    var bottleDepositTaxExistence = {
        med: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_med2 = taxExistence.med) === null || _taxExistence_med2 === void 0 ? void 0 : _taxExistence_med2.bottleDeposit,
        rec: taxExistence === null || taxExistence === void 0 ? void 0 : (_taxExistence_rec2 = taxExistence.rec) === null || _taxExistence_rec2 === void 0 ? void 0 : _taxExistence_rec2.bottleDeposit
    };
    bottleDepositTaxCents = Big(bottleDepositTaxCents, 'Bottle Deposit Tax');
    cannabisTax = Big(cannabisTax.toFixed(2), 'Cannabis Tax');
    salesTax = Big(salesTax.toFixed(2), 'Sales Tax');
    subtotal = Big(subtotal.toFixed(2), 'Subtotal');
    return {
        bottleDepositTaxCents: bottleDepositTaxCents,
        cannabisTax: cannabisTax,
        salesTax: salesTax,
        subtotal: subtotal,
        details: details,
        salesTaxExistence: salesTaxExistence,
        cannabisTaxExistence: cannabisTaxExistence,
        bottleDepositTaxExistence: bottleDepositTaxExistence
    };
};
